export default {
  'forgetpassword.forgetpassword': 'Hai dimenticato la password?',
  'forgetpassword.wrongemail': 'L email non era valida',
  'forgetpassword.resetemail':
    'Inserisci il tuo indirizzo e-mail per reimpostare la password',
  'forgetpassword.resetpassword': 'Resetta la password',
};
